<template>
  <div class="card-radio-view">
    <el-radio-group
      v-if="allowSwitch"
      :value="effectiveElementsViewMode"
      size="mini"
      @input="onChange"
    >
      <el-radio-button :label="$constants.card.elementsView.TABLE">Таблица</el-radio-button>
      <el-radio-button :label="$constants.card.elementsView.CARDS">Карточки</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "card-elements-view-switch",
  computed: {
    ...mapGetters('card', {
      allowSwitch: 'allowElementsViewSwitch',
      effectiveElementsViewMode: 'effectiveElementsViewMode',
    }),
  },
  methods: {
    onChange(viewMode) {
      this.$store.dispatch('card/saveElementsViewMode', viewMode);
    },
  }
}
</script>
